import services from '../services'
import * as types from './mutation-types'

// Lock para evitar fetches duplicados do mesmo conversation
const pendingFetches = {}
// IDs de conversas removidas recentemente (evita re-adicionar via broadcast)
const recentlyRemoved = {}
export const markAsRemoved = (id) => {
  recentlyRemoved[id] = true
  setTimeout(() => { delete recentlyRemoved[id] }, 30000) // limpa depois de 30s
}

export const getConversations = async ({ commit }, params) => {
  commit(types.SET_LOADING, true)
  try {
    const res = await services.listConversations(params)
    commit(types.SET_CONVERSATIONS, res.data)
  } finally {
    commit(types.SET_LOADING, false)
  }
}

export const selectConversation = async ({ commit }, id) => {
  const res = await services.showConversation(id)
  commit(types.SET_CONVERSATION, res.data)
  return res.data
}

export const loadMessages = async ({ commit }, { id, params }) => {
  const res = await services.getMessages(id, params)
  commit(types.SET_MESSAGES, res.data)
  return res.data
}

export const sendMessage = async ({ commit }, { id, payload }) => {
  const res = await services.sendMessage(id, payload)
  commit(types.ADD_MESSAGE, res.data)
  return res.data
}

export const sendMediaMessage = async ({ commit }, { id, formData }) => {
  const res = await services.sendMedia(id, formData)
  commit(types.ADD_MESSAGE, res.data)
  return res.data
}

export const startNewConversation = async ({ commit }, payload) => {
  const res = await services.startConversation(payload)
  return res.data
}

export const markConversationRead = async ({ commit }, id) => {
  await services.markAsRead(id)
}

export const closeConversation = async ({ commit }, id) => {
  await services.closeConversation(id)
}

export const loadTemplates = async ({ commit }, params) => {
  const res = await services.getTemplates(params)
  commit(types.SET_TEMPLATES, res.data)
  return res.data
}

export const receiveNewMessage = async ({ commit, state }, data) => {
  const convId = data.conversation_id
  const convData = data.conversation || {}

  // Ignorar se arquivada/fechada ou removida recentemente
  if (convData.archived_at || convData.status === 'closed' || recentlyRemoved[convId]) {
    return
  }

  // Adicionar mensagem se a conversa está aberta
  const isCurrentConv = state.conversation && state.conversation.id === convId
  if (isCurrentConv) {
    commit(types.ADD_MESSAGE, data.message)
    commit(types.UPDATE_CONVERSATION, { id: convId, unread_count: 0 })
    services.markAsRead(convId).catch(() => {})
    if (convData.session_expires_at) {
      commit(types.SET_CONVERSATION, Object.assign({}, state.conversation, {
        session_expires_at: convData.session_expires_at,
        session_active: true,
        last_message_at: convData.last_message_at,
        last_message_preview: convData.last_message_preview
      }))
    }
  }

  // Atualizar conversa na sidebar
  const exists = state.conversations.find(c => c.id === convId || (c.phone && convData.phone && c.phone === convData.phone))
  if (exists) {
    const update = { ...convData, id: exists.id }
    // Se é a conversa aberta, manter unread_count zerado (já foi marcada como lida acima)
    if (isCurrentConv) {
      update.unread_count = 0
    }
    commit(types.UPDATE_CONVERSATION, update)
    return
  }

  // Conversa não existe na lista — buscar da API (com lock anti-duplicação)
  if (pendingFetches[convId]) return
  pendingFetches[convId] = true

  try {
    const res = await services.showConversation(convId)
    if (!res.data.archived_at && res.data.status !== 'closed') {
      // Verificar novamente se já não foi adicionada enquanto esperávamos
      const alreadyAdded = state.conversations.find(c => c.id === convId || (c.phone && res.data.phone && c.phone === res.data.phone))
      if (!alreadyAdded) {
        commit(types.UPDATE_CONVERSATION, res.data)
      } else {
        commit(types.UPDATE_CONVERSATION, { ...res.data, id: alreadyAdded.id })
      }
    }
  } catch (e) {
    // Conversa não encontrada — ignorar
  } finally {
    delete pendingFetches[convId]
  }
}

export const receiveStatusUpdate = ({ commit }, data) => {
  commit(types.UPDATE_MESSAGE_STATUS, data)
}
